// extracted by mini-css-extract-plugin
export default {"textSuggestionsInteraction":"styles_textSuggestionsInteraction__bpuQt","triggerButton":"styles_triggerButton__5kxL9","option":"styles_option__NpxnZ"};